"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolate = void 0;
/**
 * Interpolacja tekstu
 * przykład użycia `interpolate("Test ${test} ${numericValue}", ['test', 'numericValue'], 'wartość test', 123)
 *
 * @export
 * @param {string} stringToInterpolate
 * @param {string[]} [argNames]
 * @param {...any[]} args
 * @returns {string}
 */
function interpolate(stringToInterpolate, argNames, ...args) {
    return new Function(...(argNames || []), `return \`${stringToInterpolate}\``)(...args);
}
exports.interpolate = interpolate;
//# sourceMappingURL=interpolate.js.map